/**
 * Quanto sobra para o anfitriao em um encontro pago.
 *
 * Duas camadas, e a diferenca entre elas importa:
 *
 *  - `repasse` e EXATO. E o valor que o split manda para o recebedor do
 *    anfitriao, com a mesma conta do servidor (BookingController:
 *    `pricing * empiria_fee / 100 + call_cost_fee`). Se a regra mudar la,
 *    mude aqui junto.
 *
 *  - `liquido` e ESTIMADO. No split e o anfitriao quem paga a taxa de
 *    processamento (`charge_processing_fee: true`), mas a aliquota real do
 *    Pagar.me depende da forma de pagamento e do parcelamento e nao existe no
 *    sistema. Usamos a estimativa cadastrada no backoffice (`pagarme_fee`).
 *    Este numero e SO PARA EXIBICAO - nunca para cobranca ou split.
 *
 * As taxas vem de /auth/publicRules, exposto no contexto como `rules`.
 */

// Espelham os defaults do banco. A Taxa de Intermediacao e de 50% por forca do
// item 4.2 da Politica Geral de Compra e Pagamento.
const PADRAO = { empiria_fee: 50, call_cost_fee: 1.2, pagarme_fee: 3.99 };

/**
 * Preco minimo de um encontro pago, para quando as regras publicas ainda nao
 * chegaram. O item 3.7 da politica fixa R$ 3,00, mas o gateway so aprovou
 * transacao a partir de R$ 7,00 no ultimo teste: um encontro mais barato que
 * isso e criavel e nao e comprável. O piso aqui e o real, e nao o do texto.
 * Igual a PRECO_MINIMO_PADRAO em serverEmpiria/src/Services/PlatformSettings.js
 * -- se mudar la, mude aqui.
 */
export const PRECO_MINIMO_PADRAO = 7;

export const precoMinimo = rules => Number(rules?.min_cost ?? PRECO_MINIMO_PADRAO);

export const calcularRepasse = (preco, rules) => {
    const valor = Number(preco);

    if (!Number.isFinite(valor) || valor <= 0) return null;

    const percentual = Number(rules?.empiria_fee ?? PADRAO.empiria_fee);
    const custoChamada = Number(rules?.call_cost_fee ?? PADRAO.call_cost_fee);

    const comissao = (valor * percentual) / 100;
    const taxaTotal = comissao + custoChamada;
    const repasse = valor - taxaTotal;

    const percentualPagarme = Number(rules?.pagarme_fee ?? PADRAO.pagarme_fee);
    const taxaPagarme = (valor * percentualPagarme) / 100;
    const liquido = repasse - taxaPagarme;

    return {
        bruto: valor,
        percentual,
        comissao,
        custoChamada,
        taxaTotal,
        repasse,
        percentualPagarme,
        taxaPagarme,
        liquido,
        // Quanto do preco cheio fica com o anfitriao, ja com a estimativa
        percentualLiquido: (liquido / valor) * 100,
        // O servidor recusa a compra quando o REPASSE nao e positivo. A
        // estimativa do Pagar.me nao entra nessa validacao, senao recusariamos
        // preco que o servidor aceita.
        invalido: repasse <= 0,
        // Preco em que a estimativa ja nao sobra nada, mesmo o servidor aceitando
        liquidoNegativo: liquido <= 0,
    };
};

export const emReais = valor =>
    Number(valor ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
